var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMortgage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Sell_house_-_Flaticon-2",
    "data-name": "Search results for Sell house - Flaticon-2",
    transform: "translate(-16 -16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "outline_copy_2",
    "data-name": "outline copy 2",
    transform: "translate(16 16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9994",
    "data-name": "Path 9994",
    d: "M17.5,291.5h9A1.5,1.5,0,0,0,28,290v-3h5.7l17.857,7.386a1.506,1.506,0,0,0,.441.107v.007l20.765-8.417,5.308-2.2a1.5,1.5,0,0,0,.881-1.75,7.227,7.227,0,0,0-9.3-5.1l-.046.016-14.344,5.3-4.988-2.85h3.352a7.513,7.513,0,0,0,7.348-6H70a1.5,1.5,0,0,0,1.5-1.5V260.781l.64.448,1.72-2.458-2.36-1.652V257h-.17l-12.47-8.729a1.5,1.5,0,0,0-1.72,0L44.67,257H44.5v.119l-2.36,1.652,1.721,2.458.64-.448V270.5H28V269a1.5,1.5,0,0,0-1.5-1.5h-9A1.5,1.5,0,0,0,16,269v21a1.5,1.5,0,0,0,1.5,1.5Zm42.179,0L67,288.469v.03Zm-.179-21h-3V263h3Zm-12-11.819,10.5-7.35,10.5,7.35V270.5h-6v-9A1.5,1.5,0,0,0,61,260H55a1.5,1.5,0,0,0-1.5,1.5v9h-6ZM28,273.5H57.876a4.508,4.508,0,0,1-4.243,3h-9a1.5,1.5,0,0,0-.744,2.8l10.5,6a1.5,1.5,0,0,0,1.264.1l14.976-5.535a4.237,4.237,0,0,1,4.925,1.811l-23.421,9.694-17.559-7.263A1.5,1.5,0,0,0,34,284H28Zm-9-3h6v18H19Z",
    transform: "translate(-16 -204.5)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9995",
    "data-name": "Path 9995",
    d: "M124,35.5h-9a1.5,1.5,0,0,0-1.5,1.5v3h-6.879L83.061,16.439a1.5,1.5,0,0,0-2.121,0,7.873,7.873,0,0,0,0,11.121l.44.439H41.5A1.5,1.5,0,0,0,40,29.5v27A1.5,1.5,0,0,0,41.5,58H85a1.5,1.5,0,0,0,1.5-1.5V52h1.239a10.489,10.489,0,0,1,3.019.443l13.311,3.993a1.5,1.5,0,0,0,.432.063h9V58a1.5,1.5,0,0,0,1.5,1.5h9a1.5,1.5,0,0,0,1.5-1.5V37A1.5,1.5,0,0,0,124,35.5ZM82.167,19.788,90.379,28H85.621l-2.561-2.561a4.872,4.872,0,0,1-.893-5.651ZM86.5,37H88a3,3,0,0,1,0,6H86.5Zm-3,18H43V31H83.5V43H82a7.508,7.508,0,0,0-7.5,7.5A1.5,1.5,0,0,0,76,52h7.5Zm30-1.5h-8.78l-13.1-3.931A13.483,13.483,0,0,0,87.739,49H77.757A4.508,4.508,0,0,1,82,46h6a6,6,0,1,0,0-12H86.5V31h6.879L104.939,42.56A1.5,1.5,0,0,0,106,43h7.5Zm9,3h-6v-18h6Z",
    transform: "translate(-35.5 -16)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9999",
    "data-name": "Path 9999",
    d: "M62.4,276.621V284l-1.939-1.939-2.121,2.121,4.5,4.5a1.489,1.489,0,0,0,2.119,0l0,0,4.5-4.5-2.121-2.121L65.4,284v-7.383Z",
    transform: "translate(77.404 336.627) rotate(180)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10053",
    "data-name": "Path 10053",
    d: "M32.682,201.5a5.708,5.708,0,0,1,3.853,3.849.954.954,0,0,0,.914.682.858.858,0,0,0,.147-.022.918.918,0,0,0,.131.027H60.635a.863.863,0,0,0,.116-.024.889.889,0,0,0,1.074-.653v-.005A5.707,5.707,0,0,1,65.68,201.5a.942.942,0,0,0,.655-1.05.966.966,0,0,0,.028-.141v-7.637a.863.863,0,0,0-.029-.142.941.941,0,0,0-.655-1.05,5.7,5.7,0,0,1-3.851-3.855,1.959,1.959,0,0,0-1.192-.682H37.727a.882.882,0,0,0-.142.029.943.943,0,0,0-1.05.655,5.707,5.707,0,0,1-3.853,3.853.942.942,0,0,0-.655,1.05.963.963,0,0,0-.027.142v7.637a.879.879,0,0,0,.027.133A.945.945,0,0,0,32.682,201.5Zm1.227-8.441a7.575,7.575,0,0,0,4.206-4.206H60.247a7.577,7.577,0,0,0,4.207,4.206v6.862a7.583,7.583,0,0,0-4.206,4.206H38.115a7.583,7.583,0,0,0-4.206-4.206Z",
    transform: "translate(-21.963 -169.389)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10054",
    "data-name": "Path 10054",
    d: "M133.727,230.4A5.728,5.728,0,1,0,128,224.673,5.727,5.727,0,0,0,133.727,230.4Zm0-9.546a3.818,3.818,0,1,1-3.818,3.818A3.818,3.818,0,0,1,133.727,220.854Z",
    transform: "translate(-106.509 -197.572)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10022_-_Outline",
    "data-name": "Path 10022 - Outline",
    d: "M77.709,258.614a1.96,1.96,0,1,1,1.959-1.96A1.962,1.962,0,0,1,77.709,258.614Z",
    transform: "translate(-60.993 -229.554)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10023_-_Outline",
    "data-name": "Path 10023 - Outline",
    d: "M253.71,258.614a1.96,1.96,0,1,1,1.96-1.96A1.962,1.962,0,0,1,253.71,258.614Z",
    transform: "translate(-215.992 -229.554)",
    fill: "#00641f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMortgage);
export default __webpack_public_path__ + "static/media/mortgage.36cedeca7946af7ea9a1f6db0c32644e.svg";
export { ForwardRef as ReactComponent };